import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/signin",
    name: "SignIn",
    query: { operid: Number },
    component: () => import("../views/SignIn.vue"),
  },
  {
    path: "/Dashboard",
    name: "Dashboard",

    component: () => import("../views/DashboardDs9.vue"),
  },
  {
    path: "/Autenticacion",
    name: "Autenticacion",

    component: () => import("../views/Autenticacion/Autenticacion.vue"),
  },
  {
    path: "/GestionTiempos",
    name: "GestionTiempos",
    meta: {
      permissions: "menu:gestiontiempos",
      requiresAuth: true,
    },
    component: () => import("../views/GestionTiempos.vue"),
  },
  {
    path: "/GestionEmpleados",
    name: "GestionEmpleados",
    meta: {
      permissions: "menu:gestionempleados",
      requiresAuth: true,
    },
    component: () => import("../views/GestionEmpleados/GestionEmpleados.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id",
    name: "EmployeesInfo",
    component: () => import("../views/GestionEmpleados/Employees.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Pautas",
    name: "Pautas",
    component: () => import("../views/GestionEmpleados/Pautas.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Grupos",
    name: "Grupos",
    component: () => import("../views/GestionEmpleados/Grupos.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Horarios",
    name: "Horarios",
    component: () => import("../views/GestionEmpleados/Horarios.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Modelos",
    name: "Modelos",
    component: () => import("../views/GestionEmpleados/Modelos.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Atributos",
    name: "Atributos",
    component: () => import("../views/GestionEmpleados/Atributos.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Tarjetas",
    name: "Tarjetas",
    component: () => import("../views/GestionEmpleados/Tarjetas.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Saldos",
    name: "Saldos",
    component: () => import("../views/GestionEmpleados/SaldosEnCuentas.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Relojes",
    name: "Relojes",
    component: () => import("../views/GestionEmpleados/Relojes.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Etiquetas",
    name: "EtiquetasEmp",
    component: () => import("../views/GestionEmpleados/Etiquetas.vue"),
  },
  {
    path: "/GestionEmpleados/info/:emp_id/Permisos",
    name: "Permisos",
    component: () => import("../views/GestionEmpleados/Permisos.vue"),
  },
  {
    path: "/FlujosTrabajo",
    name: "Flujo de trabajo",
    meta: {
      permissions: "menu:flujostrabajo",
      requiresAuth: true,
    },
    component: () => import("../views/workflow/Workflow.vue"),
  },
  {
    path: "/FlujosTrabajo/def/niveles",
    name: "Niveles",
    component: () => import("../views/workflow/Levels.vue"),
  },
  {
    path: "/FlujosTrabajo/def/atributos",
    name: "Atributos workflow",
    component: () => import("../views/workflow/Attributes.vue"),
  },
  {
    path: "/FlujosTrabajo/def/empleados",
    name: "Empleados",
    component: () => import("../views/workflow/Employees.vue"),
  },
  {
    path: "/FlujosTrabajo/def/filtros",
    name: "Filtros",
    component: () => import("../views/workflow/Filters.vue"),
  },
  {
    path: "/FlujosTrabajo/def/procesos",
    name: "Procesos",

    component: () => import("../views/workflow/Process.vue"),
  },
  {
    path: "/Etiquetas",
    name: "Etiquetas",
    component: () => import("../views/Etiquetas/Tags.vue"),
  },
  {
    path: "/Autorizaciones",
    name: "Autorizaciones",
    meta: {
      permissions: "menu:autorizaciones",
      requiresAuth: true,
    },

    component: () => import("../views/Autorizaciones/Authorization.vue"),
  },
  {
    path: "/Horarios",
    name: "HorariosDef",
    meta: {
      permissions: "menu:horarios",
      requiresAuth: true,
    },

    component: () => import("../views/Horarios/Schedules"),
  },

  {
    path: "/Conceptos",
    name: "Conceptos",
    meta: {
      permissions: "menu:conceptos",
      requiresAuth: true,
    },

    component: () => import("../views/Conceptos/Conceptos"),
  },

  {
    path: "/GruposFeriados",
    name: "gruposDeFeriados",
    meta: {
      permissions: "menu:grupoferiados",
      requiresAuth: true,
    },

    component: () => import("../views/GruposDeFeriados/GruposDeFeriados"),
  },
  {
    path: "/Grupos",
    name: "grupos",
    meta: {
      permissions: "menu:grupos",
      requiresAuth: true,
    },
    component: () => import("../views/Grupos/Groups"),
  },
  {
    component: () => import("../views/Grupos/Groups"),
    path: "/CentrosCosto",
    name: "centroDeCostos",
    meta: {
      permissions: "menu:centroscosto",
      requiresAuth: true,
    },

    component: () => import("../views/CentrosDeCosto/CentrosDeCosto"),
  },
  {
    path: "/Modelos",
    name: "modelosDeLiquidacion",
    meta: {
      permissions: "menu:modelos",
      requiresAuth: true,
    },

    component: () =>
      import("../views/ModelosDeLiquidacion/ModelosDeLiquidacion"),
  },
  {
    path: "/ConceptosSueldos",
    name: "conceptosDeSueldo",
    meta: {
      permissions: "menu:csueldos",
      requiresAuth: true,
    },

    component: () => import("../views/ConceptosDeSalarios/ConceptosDeSalarios"),
  },
  {
    path: "/Tarjetas",
    name: "tarjetas",
    meta: {
      permissions: "menu:tarjetas",
      requiresAuth: true,
    },

    component: () => import("../views/Tarjetas/Cards.vue"),
  },
  {
    path: "/Atributos",
    name: "atributos",
    meta: {
      permissions: "menu:atributos",
      requiresAuth: true,
    },

    component: () => import("../views/Atributos/Attributes.vue"),
  },
  {
    path: "/Reportes",
    name: "reportes",
    meta: {
      permissions: "menu:reportes",
      requiresAuth: true,
    },

    component: () => import("../views/Reportes/Reports"),
  },
  {
    path: "/Liquidaciones",
    name: "liquidaciones",
    meta: {
      permissions: "menu:liquidaciones",
      requiresAuth: true,
    },

    component: () => import("../views/Liquidaciones/Liquidaciones"),
  },
  {
    path: "/MonitorCA3",
    name: "monitor",
    meta: {
      permissions: "menu:monitorca3",
      requiresAuth: true,
    },

    component: () => import("../views/Monitor/Monitor"),
  },
  {
    path: "/Operadores",
    name: "operadores",
    meta: {
      permissions: "menu:operadores",
      requiresAuth: true,
    },

    component: () => import("../views/Operadores/Operators"),
  },
  {
    path: "/UnidadesNegocios",
    name: "unidadesDeNegocios",
    meta: {
      permissions: "menu:operadores",
      requiresAuth: true,
    },

    component: () => import("../views/UnidadesDeNegocios/businessUnits"),
  },
  {
    path: "/PermisosDeAcceso",
    name: "permisosDeAcceso",
    meta: {
      permissions: "menu:permisos",
      requiresAuth: true,
    },

    component: () => import("../views/PermisosDeAcceso/AccessPermissions"),
  },
  {
    path: "/Pcas",
    name: "pcas",
    meta: {
      permissions: "menu:pcasroles",
      requiresAuth: true,
    },

    component: () => import("../views/Pcas/Pcas"),
  },
  {
    path: "/Comentarios",
    name: "comentarios",
    meta: {
      permissions: "menu:comentarios",
      requiresAuth: true,
    },

    component: () => import("../views/Comentarios/Comentarios"),
  },
  {
    path: "/CargaDeLicencias",
    name: "cargaDeLicencias",
    meta: {
      permissions: "menu:cargalicencias",
      requiresAuth: true,
    },

    component: () => import("../views/CargaDeLicencias/LicenseUpload"),
  },
  {
    path: "/CuentasCorrientes",
    name: "cuentasCorrientes",
    meta: {
      permissions: "menu:cuentascorrientes",
      requiresAuth: true,
    },
    component: () => import("../views/CuentasCorrientes/CurrentAccounts"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve(async (to, from, next) => {
  let isAuthenticated = localStorage.getItem("token");
  let operId = to.query.operId;
  const hasTwoFAEnabled =
    localStorage.getItem("dialogTwoFA") &&
    localStorage.getItem("active2fa") === "true";

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const userAccess = localStorage.getItem("asegurables");
    const requiredPermissions = to.meta.permissions;

    if (userAccess && userAccess.includes(requiredPermissions)) {
      next();
    } else {
      next("/Dashboard");
    }
  } else {
    next();
  }

  if (hasTwoFAEnabled) {
    return next("/Autenticacion");
  }

  if (to.name === "SignIn" && isAuthenticated) {
    return next({ name: "Dashboard" });
  }

  if (to.name !== "SignIn" && !isAuthenticated) {
    return next({ name: "SignIn" });
  }

  if (to.name === "SignIn" && !isAuthenticated && operId) {
    localStorage.setItem("operIdLogin", operId);
  }

  return next();
});

export default router;
